export default "__VITE_ASSET__Ca0ZdU4s__"